import { render } from "./QuizProperties.vue?vue&type=template&id=24532b4e"
import script from "./QuizProperties.vue?vue&type=script&lang=js"
export * from "./QuizProperties.vue?vue&type=script&lang=js"

import "./QuizProperties.vue?vue&type=style&index=0&id=24532b4e&lang=scss"
script.render = render

export default script